// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD0EO3yuFP0uXhY2iUkUp3_hNjZF4gUwBU",
  authDomain: "portfolio-data-9afbf.firebaseapp.com",
  projectId: "portfolio-data-9afbf",
  storageBucket: "portfolio-data-9afbf.appspot.com",
  messagingSenderId: "150259055521",
  appId: "1:150259055521:web:287d6203fb5178cd1ca9e0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
